import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-confirm-title" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppConfirmModal',
  props: {
  title: {
    type: String,
    required: true,
  },
},
  emits: ["confirm", "cancel"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
  }, {
    title: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.title), 1)
    ]),
    body: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('confirm')))
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Yes", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_n_button, {
            variant: "primary--outline",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})